module.exports = __webpack_public_path__ + "static/media/page-08-bg.4bda3be4.png";